const TextDivPlaceHolder = (props) => {
    return <div class="center-hv" style={props.style}>
        <p className='header'>{props.header}</p>
        <p className='content'>{props.content}</p>
    </div>;
}

export {
    TextDivPlaceHolder
}